"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createFromTdpNode = exports.isTdpTemplate = exports.getTemplateName = exports.TdpCapabilityOptions = void 0;
const localizeUtils_1 = require("../../../common/localizeUtils");
const utils_1 = require("../../../component/driver/teamsApp/utils/utils");
const templateNames_1 = require("../../../component/generator/templates/templateNames");
const constants_1 = require("../../constants");
const create_1 = require("../../create");
const createRootNode_1 = require("./createRootNode");
const customAgentProjectTypeNode_1 = require("./customAgentProjectTypeNode");
const daProjectTypeNode_1 = require("./daProjectTypeNode");
const ProjectTypeOptions_1 = require("./ProjectTypeOptions");
const teamsProjectTypeNode_1 = require("./teamsProjectTypeNode");
const featureFlags_1 = require("../../../common/featureFlags");
class TdpCapabilityOptions {
    static me() {
        return {
            id: "message-extension",
            label: (0, localizeUtils_1.getLocalizedString)("core.MessageExtensionOption.label"),
            description: (0, localizeUtils_1.getLocalizedString)("core.MessageExtensionOption.description"),
            detail: (0, localizeUtils_1.getLocalizedString)("core.MessageExtensionOption.detail"),
            data: templateNames_1.TemplateNames.MessageExtension,
        };
    }
    static botAndMe() {
        return {
            id: "BotAndMessageExtension",
            label: "",
            data: templateNames_1.TemplateNames.BotAndMessageExtension,
        };
    }
    static nonSsoTabAndBot() {
        return {
            id: "TabNonSsoAndBot",
            label: "",
            data: templateNames_1.TemplateNames.TabAndDefaultBot,
        };
    }
    static nonSsoTab() {
        return {
            id: "tab-non-sso",
            label: `${(0, localizeUtils_1.getLocalizedString)("core.TabNonSso.label")}`,
            detail: (0, localizeUtils_1.getLocalizedString)("core.TabNonSso.detail"),
            description: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.option.description.worksInOutlookM365"),
            data: templateNames_1.TemplateNames.Tab,
        };
    }
}
exports.TdpCapabilityOptions = TdpCapabilityOptions;
function getTemplateName(inputs) {
    if (inputs.teamsAppFromTdp) {
        const teamsApp = inputs.teamsAppFromTdp;
        // tab with bot, tab with message extension, tab with bot and message extension
        if ((0, utils_1.needTabAndBotCode)(teamsApp)) {
            return templateNames_1.TemplateNames.TabAndDefaultBot;
        }
        // tab only
        if ((0, utils_1.needTabCode)(teamsApp)) {
            return templateNames_1.TemplateNames.Tab;
        }
        // bot and message extension
        if ((0, utils_1.isBotAndBotBasedMessageExtension)(teamsApp)) {
            return templateNames_1.TemplateNames.BotAndMessageExtension;
        }
        // bot based message extension
        if ((0, utils_1.isBotBasedMessageExtension)(teamsApp)) {
            return templateNames_1.TemplateNames.MessageExtension;
        }
        // bot
        if ((0, utils_1.isBot)(teamsApp)) {
            return templateNames_1.TemplateNames.DefaultBot;
        }
    }
    else if (featureFlags_1.featureFlagManager.getBooleanValue(featureFlags_1.FeatureFlags.TdpTemplateCliTest) &&
        inputs.nonInteractive) {
        const capability = inputs[constants_1.QuestionNames.Capabilities];
        const map = {
            [TdpCapabilityOptions.me().id]: templateNames_1.TemplateNames.MessageExtension,
            [TdpCapabilityOptions.nonSsoTab().id]: templateNames_1.TemplateNames.Tab,
            [TdpCapabilityOptions.botAndMe().id]: templateNames_1.TemplateNames.BotAndMessageExtension,
            [TdpCapabilityOptions.nonSsoTabAndBot().id]: templateNames_1.TemplateNames.TabAndDefaultBot,
        };
        const value = map[capability];
        return value;
    }
}
exports.getTemplateName = getTemplateName;
function isTdpTemplate(inputs) {
    const template = getTemplateName(inputs);
    return template !== undefined;
}
exports.isTdpTemplate = isTdpTemplate;
function createFromTdpNode() {
    const node = {
        data: { type: "group" },
        children: [
            {
                // templateName is decided by teamsAppFromTdp itself
                condition: (inputs) => getTemplateName(inputs) !== undefined,
                data: {
                    type: "singleSelect",
                    name: constants_1.QuestionNames.TemplateName,
                    title: "Select a template",
                    staticOptions: [],
                    dynamicOptions: (inputs) => {
                        const templateName = getTemplateName(inputs);
                        return [templateName];
                    },
                    skipSingleOption: true,
                },
            },
            {
                // templateName can not decided by teamsAppFromTdp itself, need user input
                condition: (inputs) => getTemplateName(inputs) === undefined,
                data: {
                    name: constants_1.QuestionNames.ProjectType,
                    title: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.title"),
                    type: "singleSelect",
                    staticOptions: [
                        ProjectTypeOptions_1.ProjectTypeOptions.declarativeAgent(),
                        ProjectTypeOptions_1.ProjectTypeOptions.customEngineAgent(),
                        ProjectTypeOptions_1.ProjectTypeOptions.bot(),
                        ProjectTypeOptions_1.ProjectTypeOptions.tab(),
                        ProjectTypeOptions_1.ProjectTypeOptions.me(),
                    ],
                },
                children: [
                    (0, daProjectTypeNode_1.daProjectTypeNode)(),
                    (0, customAgentProjectTypeNode_1.customEngineAgentProjectTypeNode)(),
                    (0, teamsProjectTypeNode_1.botProjectTypeNode)(),
                    (0, teamsProjectTypeNode_1.tabProjectTypeNode)(),
                    (0, teamsProjectTypeNode_1.meProjectTypeNode)(),
                ],
            },
            {
                condition: (inputs) => !!inputs.teamsAppFromTdp && (0, utils_1.isPersonalApp)(inputs.teamsAppFromTdp),
                data: { type: "group", name: constants_1.QuestionNames.RepalceTabUrl },
                children: [
                    {
                        condition: (inputs) => {
                            var _a;
                            return (((_a = inputs.teamsAppFromTdp) === null || _a === void 0 ? void 0 : _a.staticTabs.filter((o) => !!o.websiteUrl)) || []).length >
                                0;
                        },
                        data: (0, create_1.selectTabWebsiteUrlQuestion)(),
                    },
                    {
                        condition: (inputs) => {
                            var _a;
                            return !!inputs.teamsAppFromTdp &&
                                (((_a = inputs.teamsAppFromTdp) === null || _a === void 0 ? void 0 : _a.staticTabs.filter((o) => !!o.contentUrl)) || []).length >
                                    0;
                        },
                        data: (0, create_1.selectTabsContentUrlQuestion)(),
                    },
                ],
            },
            {
                condition: (inputs) => !!inputs.teamsAppFromTdp && (0, utils_1.needBotCode)(inputs.teamsAppFromTdp),
                data: (0, create_1.selectBotIdsQuestion)(),
            },
            (0, createRootNode_1.languageNode)(),
            {
                data: (0, create_1.folderQuestion)(),
            },
            {
                data: (0, create_1.appNameQuestion)(),
            },
        ],
    };
    return node;
}
exports.createFromTdpNode = createFromTdpNode;
//# sourceMappingURL=createFromTdpNode.js.map